import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AdminCenterService } from '../wsp_admin_center_sdk/admin-center.service';
import { GetAppConfigResponse } from '../wsp_admin_center_sdk/_internal/objects';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class AppConfigService {
  constructor(private adminCenterApiService: AdminCenterService) {}

  getAppConfig(partnerId: string): Observable<GetAppConfigResponse> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(catchError((err) => throwError(err)));
  }

  getShowAdvancedFeaturesFlag(partnerId: string): Observable<boolean> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(
      map((res: GetAppConfigResponse) => !!res.config.showAdvancedFeatures),
      catchError((err) => throwError(err)),
    );
  }

  setShowAdvancedFeaturesFlag(partnerId: string, showAdvancedFeaturesFlag: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowAdvancedFeatures(partnerId, showAdvancedFeaturesFlag);
  }

  getShowIncludedTemplatesFlag(partnerId: string): Observable<boolean> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(
      map((res: GetAppConfigResponse) => !!res.config.showIncludedTemplates),
      catchError((err) => throwError(err)),
    );
  }

  setShowIncludedTemplatesFlag(partnerId: string, showIncludedTemplatesFlag: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowIncludedTemplates(partnerId, showIncludedTemplatesFlag);
  }

  getDomainsFeatures(partnerId: string): Observable<boolean> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(
      map((res: GetAppConfigResponse) => !!(res.config as any).showDomainsFeatures),
      catchError((err) => throwError(err)),
    );
  }

  setDomainsFeatures(partnerId: string, domainsFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowDomainsFeatures(partnerId, domainsFeatures);
  }

  getImportFeatures(partnerId: string): Observable<boolean> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(
      map((res: GetAppConfigResponse) => !!(res.config as any).showImportFeatures),
      catchError((err) => throwError(err)),
    );
  }

  setImportFeatures(partnerId: string, importFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowImportFeatures(partnerId, importFeatures);
  }

  getBackupsFeatures(partnerId: string): Observable<boolean> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(
      map((res: GetAppConfigResponse) => !!(res.config as any).showBackupsFeatures),
      catchError((err) => throwError(err)),
    );
  }

  setBackupsFeatures(partnerId: string, backupsFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowBackupsFeatures(partnerId, backupsFeatures);
  }

  getStagingFeatures(partnerId: string): Observable<boolean> {
    return this.adminCenterApiService.getAppConfig(partnerId).pipe(
      map((res: GetAppConfigResponse) => !!(res.config as any).showStagingFeatures),
      catchError((err) => throwError(err)),
    );
  }

  setStagingFeatures(partnerId: string, stagingFeatures: boolean): Observable<HttpResponse<null>> {
    return this.adminCenterApiService.setShowStagingFeatures(partnerId, stagingFeatures);
  }
}
